<template>
    <div v-if="showTags" class="tags">
        <ul ref="scrollWrapper">
            <li v-for="(item,index) in tagsList" :key="index" class="tags-li" :class="{'active': isActive(item.path)}" :title="item.title">
                <router-link :to="item.path" class="tags-li-title">
                    {{ item.title }}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close" /></span>
            </li>
        </ul>
        <div class="tags-close-box">
            <el-dropdown @command="handleTags">
                <el-button size="mini" type="default">
                    <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu slot="dropdown" size="small">
                    <el-dropdown-item command="other">
                        关闭其他
                    </el-dropdown-item>
                    <el-dropdown-item command="all">
                        关闭所有
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import bus from './bus';
export default {
    data() {
        return {
            tagsList: []
        }
    },
    computed: {
        showTags() {
            return this.tagsList.length > 0;
        }
    },
    watch: {
        $route(newValue) {
            this.setTags(newValue);
            this.moveToCurrentTag()
        }
    },
    created() {
        this.setTags(this.$route);
        // 监听关闭当前页面的标签页
        bus.$on('close_current_tags', () => {
            for (let i = 0, len = this.tagsList.length; i < len; i++) {
                const item = this.tagsList[i];
                if (item.path === this.$route.fullPath) {
                    if (i < len - 1) {
                        this.$router.push(this.tagsList[i + 1].path);
                    } else if (i > 0) {
                        this.$router.push(this.tagsList[i - 1].path);
                    } else {
                        this.$router.push('/');
                    }
                    this.tagsList.splice(i, 1);
                    break;
                }
            }
        })
    },
    mounted() {
        this.moveToCurrentTag()
    },
    methods: {
        moveToCurrentTag(){
            this.$nextTick(()=>{
                const exist = this.tagsList.findIndex(item=>item.path==this.$route.path)
                if(exist>-1){
                    this.$refs.scrollWrapper.scrollLeft = document.getElementsByClassName('tags-li')[exist].offsetLeft - 3
                }else{
                    this.$refs.scrollWrapper.scrollLeft = 999999
                }

            })
        },
        isActive(path) {
            return path === this.$route.fullPath;
        },
        // 关闭单个标签
        closeTags(index) {
            const delItem = this.tagsList.splice(index, 1)[0];
            const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
            if (item) {
                delItem.path === this.$route.fullPath && this.$router.push(item.path);
            } else {
                this.$router.push('/');
            }
        },
        // 关闭全部标签
        closeAll() {
            this.tagsList = [];
            this.$router.push('/');
        },
        // 关闭其他标签
        closeOther() {
            const curItem = this.tagsList.filter(item => {
                return item.path === this.$route.fullPath;
            })
            this.tagsList = curItem;
        },
        // 设置标签
        setTags(route) {
            const isExist = this.tagsList.some(item => {
                return item.path === route.fullPath;
            })
            if (!isExist) {
                if (this.tagsList.length >= 12) {
                    /* this.$message({
                        showClose: true,
                        message: '当前打开窗口过多，请关闭部分窗口',
                        type: "warning"
                    }); */
                    this.tagsList.shift();
                }
                this.tagsList.push({
                    title: route.meta.title,
                    path: route.fullPath
                })
            }
            bus.$emit('tags', this.tagsList);
        },
        handleTags(command) {
            command === 'other' ? this.closeOther() : this.closeAll();
        }
    }
}

</script>


<style lang="scss" scoped>
.tags {
    position: relative;
    height: 35px;
    overflow: hidden;
    background: #fff;
    padding-right: 60px;
    box-shadow: 0 5px 10px -5px #ddd;
    z-index: 99;
    user-select: none;
}

.tags ul {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    position: relative;
}

.tags-li {
    //float: left;
    margin: 4px 5px 2px 3px;
    border-radius: 3px;
    font-size: 12px;
    overflow: hidden;
    cursor: pointer;
    height: 23px;
    line-height: 23px;
    border: 1px solid #e9eaec;
    background: #fff;
    padding: 0 5px 0 12px;
    vertical-align: middle;
    color: #666;
    -webkit-transition: all 0.3s ease-in;
    -moz-transition: all 0.3s ease-in;
    transition: all 0.3s ease-in;
    display: inline-block;
}

.tags-li:not(.active):hover {
    background: #f8f8f8;
}

.tags-li.active {
    color: #fff;
    border: 1px solid #2f39ff;
    background-color: #2f39ff;
}

.tags-li-title {
    float: left;
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 5px;
    color: #666;
}

.tags-li.active .tags-li-title {
    color: #fff;
}

.tags-close-box {
    position: absolute;
    right: 0;
    top: 0;
    box-sizing: border-box;
    padding-top: 1px;
    text-align: center;
    // width: 110px;
    height: 30px;
    background: #fff;
    box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
    z-index: 10;
    .el-icon--right {
        margin-left: 0;
    }
}


::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

:hover::-webkit-scrollbar-track {
    background-color:rgba(241,241,241,0.3);
}

:hover::-webkit-scrollbar-thumb {
    background-color:rgba(130,130,130,0.3);
    border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/tags.vue